export const normalizeNoteStatus = (status) => (status || '').toString().trim().toLowerCase()

export const isSubmittedNoteStatus = (status) => ['draft', 'drafted', 'in draft', 'submitted'].includes(normalizeNoteStatus(status))
export const isSignedNoteStatus = (status) => ['signed'].includes(normalizeNoteStatus(status))
export const isFinishedOrCanceledNoteStatus = (status) => ['finished', 'canceled', 'cancelled'].includes(normalizeNoteStatus(status))

export const hasScheduledAppointment = (appointment = [], patientAppointmentID) => {
  if (!Array.isArray(appointment) || !patientAppointmentID) return false
  return appointment.some((item) => {
    if (!item?.data) return false
    const appointmentId = item.data.AppointmentID
    const status = item.data.Status
    return (
      appointmentId?.toString() === patientAppointmentID?.toString() &&
      (status === 'Scheduled' || status === 'Rescheduled' || !!item?.data?.StartTime)
    )
  })
}

export const getLatestNoteStatus = (patientTreatments = []) => {
  if (!Array.isArray(patientTreatments) || patientTreatments.length === 0) return null
  const latest = patientTreatments[0]
  return latest?.status || latest?.Status || null
}

export const shouldDisableCreateNote = ({
  context = 'dashboard',
  appointment = [],
  patientAppointmentID,
  patientTreatments,
}) => {
  const treatments = Array.isArray(patientTreatments) ? patientTreatments : []
  const latestStatus = getLatestNoteStatus(treatments)

  if (isSubmittedNoteStatus(latestStatus)) return true
  if (isSignedNoteStatus(latestStatus)) return false
  if (isFinishedOrCanceledNoteStatus(latestStatus)) return true

  const scheduled = hasScheduledAppointment(appointment, patientAppointmentID)
  if (!scheduled) return true

  if (context === 'dashboard') {
    return treatments.length > 0
  }

  // scheduler can create a note whenever an appointment exists and no blocking status is present
  return false
}

export const getCreateNoteDisabledReason = ({
  context = 'dashboard',
  appointment = [],
  patientAppointmentID,
  patientTreatments,
}) => {
  const treatments = Array.isArray(patientTreatments) ? patientTreatments : []
  const latestStatus = getLatestNoteStatus(treatments)

  if (isSubmittedNoteStatus(latestStatus)) return 'An Active Note Already Exists'
  if (isFinishedOrCanceledNoteStatus(latestStatus)) return 'Latest Note Is Finished Or Canceled'

  const scheduled = hasScheduledAppointment(appointment, patientAppointmentID)
  if (!scheduled) return 'No Appointment Created'

  if (context === 'dashboard' && treatments.length > 0 && !isSignedNoteStatus(latestStatus)) {
    return 'A Note Record Already Exists'
  }

  return ''
}
